import React from 'react';
import { observer, inject } from 'mobx-react';

import { Ehr } from '@patient/store/ehr/Ehr';

import { MobileView } from './MobileView';
import { action, makeObservable, observable } from 'mobx';

interface StoreProps {
    ehr: Ehr;
}

const injectableStores: (keyof StoreProps)[] = [Ehr.Name];

@observer
class Component extends React.Component<StoreProps> {
    @observable public isPatientInfoShowing = false;

    constructor(props: StoreProps) {
        super(props);
        makeObservable(this);
    }

    public render(): React.ReactNode {
        const { ehr } = this.props;

        return React.createElement(MobileView, {
            isPatientInfoShowing: this.isPatientInfoShowing,
            patientName: ehr.initials,
            togglePatientInfoShowing: this.togglePatientInfoShowing,
        });
    }

    @action.bound
    private togglePatientInfoShowing(): void {
        this.isPatientInfoShowing = !this.isPatientInfoShowing;
    }
}

export const MobileViewContainer = inject<{}, StoreProps>(...injectableStores)(Component);
